import { render, staticRenderFns } from "./RangesSelector.vue?vue&type=template&id=12456730&scoped=true&lang=pug"
import script from "./RangesSelector.vue?vue&type=script&lang=js"
export * from "./RangesSelector.vue?vue&type=script&lang=js"
import style0 from "./RangesSelector.vue?vue&type=style&index=0&id=12456730&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12456730",
  null
  
)

export default component.exports